import { OpenAPIParameterType } from "../core";

/**
 * OpenAPI `$ref` reference object
 */
export type ReferenceObject = {
  $ref: string;
};

/**
 * OpenAPI schema object (subset of the JSON Schema dialect used by OpenAPI)
 */
export type SchemaObject = {
  type?: OpenAPIParameterType;
  format?: string;
  items?: SchemaObject | ReferenceObject;
  properties?: {
    [propertyName: string]: SchemaObject | ReferenceObject;
  };
  required?: string[];
  enum?: unknown[];
  oneOf?: (SchemaObject | ReferenceObject)[];
  allOf?: (SchemaObject | ReferenceObject)[];
  anyOf?: (SchemaObject | ReferenceObject)[];
  not?: SchemaObject | ReferenceObject;
  description?: string;
  default?: unknown;
  nullable?: boolean;
  readOnly?: boolean;
  writeOnly?: boolean;
  example?: unknown;
  deprecated?: boolean;
  additionalProperties?: boolean | SchemaObject | ReferenceObject;
};

/**
 * Handler types for field processing
 */
export enum HandlerType {
  /** Handle by agent - user provides input */
  USER = "USER",
  /** Handle by creator - preset value */
  CREATOR = "CREATOR",
  /** Handle by agent - AI fills automatically */
  AGENT = "AGENT",
  /** Field is disabled */
  DISABLED = "DISABLED"
}

/**
 * Field type definition for form fields and schema generation
 */
export interface Field {
  label: string;
  path?: string[] | string; // Path to the field in the schema
  type: string;
  description?: string;
  required?: boolean;
  schema: SchemaObject | ReferenceObject;
  handler?: HandlerType | string; // Allow string for backward compatibility
  default?: unknown;
  enum?: any;
  "x-enum-description"?: unknown; // Descriptions for enum values
  example?: unknown;
  value?: any; // Current value of the field
}
